import { render, staticRenderFns } from "./ImageWithDescriptions.vue?vue&type=template&id=840fa250&scoped=true&"
import script from "./ImageWithDescriptions.vue?vue&type=script&lang=js&"
export * from "./ImageWithDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithDescriptions.vue?vue&type=style&index=0&id=840fa250&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840fa250",
  null
  
)

export default component.exports